/** @jsx jsx */

import { useContext, useRef } from 'react';
import { css, jsx } from '@emotion/core';
import EditMarker from 'components/UI/EditMarker';
import { colors, getButtonFocus } from 'styles/variables';
import setCurrentBlock from 'services/apiHelpers/setCurrentBlock';
import { connect } from 'react-redux';
import { Button, Box } from '@chameleoncreator/creator-ui';
import { InteractionContext } from '../../Layouts/ContainerLogical';
import { useLayoutEffect } from 'react';
import checkButtonColors from 'services/checkButtonColors';
import getStore from 'services/getStore';
import isIE from 'services/isIE';

const store = getStore();

const { getState } = getStore();

const { lPink } = colors;

interface IEditable {
  isEditActive: boolean;
  children: any;
  lockDown: boolean;
  id: string;
  shape?: string;
  background?: string;
  foreground?: string;
  label?: string;
  color?: string;
  borderWidth?: string;
  borderColor?: string;
  borderRadius?: number | string;
  font?: string;
  focusColor?: string;
  onClick?: () => void;
}

const DButton = ({
  id,
  shape,
  background,
  foreground,
  borderWidth,
  borderColor,
  borderRadius,
  buttonOutline,
  buttonShadow,
  font = '',
  focusColor,
  children,
  onClick,
  ...props
}) => {
  const shapeStyle = {
    pill: 'border-radius: 9999px',
    rectangle: `border-radius: ${borderRadius}px`,
    circle: 'border-radius: 50%',
  }[shape];

  const btn = useRef(null);

  const { fontFamily: fontFromTheme } = store.getState().theme;

  useLayoutEffect(() => {
    if (shape === 'circle') {
      btn.current.style.height = `${btn.current.offsetWidth}px`;
      return;
    }
    btn.current.style.height = 'auto';
    btn.current.style.minHeight = '45px';

    if (isIE()) {
      const h = btn.current.querySelector('#ie-btn-children-container')
        .scrollHeight;
      // console.log(h);

      btn.current.style.height = `${h + 10}px`;
    }
  });

  // old values :
  // ${shape !== 'circle' && 'min-width: 230px;'}
  // white-space: ${shape !== 'circle' ? 'nowrap' : 'wrap'};
  // line-height: 1.6;

  // ${borderColor && `border: ${borderWidth}px solid ${borderColor};`}

  let { enabled } = props;
  if (window.dev()) {
    enabled = true;
  }

  return (
    <Button
      ref={btn}
      id={`i${id}`}
      px={4}
      py={2}
      // bg={borderWidth === 0 ? background : 'transparent'}
      bg={buttonOutline ? 'transparent' : background}
      color={foreground}
      display={'flex'}
      disabled={enabled !== undefined ? !enabled : false}
      // disabled={!enabled}
      css={css`
      position: relative;
        justify-content: center;
        align-items: center;

        ${shape !== 'circle' && 'width: 230px;'}
        // min-width: 230px;
        // white-space: wrap;
        word-break: ${shape === 'circle' ? 'normal' : 'break-word'};
        line-height: 1.2;

        ${shapeStyle};
        cursor: pointer;
        outline: none;
        border: 1px solid ${background};
        font-family: ${font || fontFromTheme} !important;
        font-size: 14px;
        ${(!font || !fontFromTheme) &&
          `font-weight: 500 !important; font-style: normal;`}
          
          ${buttonShadow && `box-shadow: 0 0 12px 3px rgba(0, 0, 0, 0.09);`}

        transition: background, border, color, opacity 0.2s;

        ${!window.dev() && 'margin: 0px 10px;'}

        &:hover {
          opacity: 0.45;
        }

        &:focus {
          //
          ${getButtonFocus(focusColor || background)}
        }

        // where did the left margin come into this thing ?
        ${!window.dev() && `margin: 0;`}
      `}
      onClick={e => {
        if (window.dev()) {
          return;
        }
        onClick();
      }}
    >
      {/* <link
        href={`https://fonts.googleapis.com/css?family=${font}:400`}
        rel="stylesheet"
      /> */}
      {isIE() ? (
        <div
          id="ie-btn-children-container"
          css={css`
            position: absolute;
            left: 0;
            top: 50%;
            width: 100%;
            padding: 0 15px;
            transform: translateY(-50%);
            word-wrap: break-word;
          `}
        >
          {children}
        </div>
      ) : (
        children
      )}
    </Button>
  );
};

export default DButton;
